<template>
    <div>
        <section class="w-full bg-blue-100">
            <div class="bg-white rounded-b-2xl">
                <div class="self-gutter">
                    <div class="self-gutter-y self-content">
                        <!--                        v-if ärikliet-->
                        <h1 v-if="customerType === 'O'" class="title-2xl">{{ customerInfo.companyname }} {{ customerInfo.title }}</h1>

                        <div v-if="customerType !== 'P'" class="pt-24 self-hero-intro">
                            <p>{{ $t('dashboard.desc_o') }}</p>
                        </div>
                        <!--                        v-if eraklient-->
                        <h1 v-if="customerType === 'P'" class="title-2xl">
                            {{ $t('dashboard.greeting') }}, {{ customerInfo.firstname }} {{ customerInfo.lastname }}
                        </h1>

                        <div v-if="customerType === 'P'" class="pt-24 self-hero-intro">
                            <p>{{ $t('dashboard.desc_p') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <article>
            <section class="bg-blue-100 self-gutter-y">
                <div class="self-gutter">
                    <div class="self-content">
                        <div class="flex flex-wrap w-full md:flex-nowrap">
                            <!--                            v-if eraklient-->
                            <div
                                v-if="customerType === 'P'"
                                class="order-1 w-full sm:pt-24 sm:order-2 sm:w-3/6 sm:pr-12 md:w-2/6 md:order-1 md:pt-0 md:pr-0"
                            >
                                <GoldCard v-if="customerInfo.customer_cards && customerInfo.customer_cards.length" />
                            </div>
                            <!--                            v-if äriklient-->
                            <div
                                v-if="customerType === 'O'"
                                class="order-2 w-full pt-24 sm:pt-0 sm:order-1 md:w-4/6 md:order-2 md:pr-24 xl:pr-48"
                            >
                                <!--                                TODO: disable these links when customerinfo is fetching but don't mess up the styling-->
                                <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/info`">
                                    <Card
                                        :title="$t('dashboard.cards.org_info.title')"
                                        :icon-notes="true"
                                        :intro="$t('dashboard.cards.org_info.intro')"
                                        tag-content="Viimati muudetud 12.12.2023"
                                        tag-color="gray-50"
                                    />
                                </router-link>
                                <router-link
                                    :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/travels-report`"
                                    disabled
                                >
                                    <Card
                                        class="mt-12"
                                        :title="$t('dashboard.cards.travel_reports.title')"
                                        :icon-docs="true"
                                        :intro="$t('dashboard.cards.travel_reports.intro')"
                                        tag-content="2 vaatamata faili"
                                        tag-color="yellow-200"
                                    />
                                </router-link>
                                <router-link
                                    :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/invoice-report`"
                                    disabled
                                >
                                    <Card
                                        class="mt-12"
                                        :title="$t('dashboard.cards.reports.title')"
                                        :icon-reports="true"
                                        :intro="$t('dashboard.cards.reports.intro')"
                                        tag-content=""
                                        tag-color=""
                                    />
                                </router-link>
                            </div>
                            <!--                            v-if eraklient-->
                            <div
                                v-if="customerType === 'P'"
                                class="order-2 w-full pt-24 sm:pt-0 sm:order-1 md:w-4/6 md:order-2 md:self-gutter"
                            >
                                <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/info`">
                                    <Card
                                        :title="$t('dashboard.cards.my_info.title')"
                                        :icon-notes="true"
                                        :intro="$t('dashboard.cards.my_info.intro')"
                                        tag-content="Viimati muudetud 12.12.2023"
                                        tag-color="gray-50"
                                    />
                                </router-link>
                                <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/invoice-report`">
                                    <Card
                                        class="mt-12"
                                        :title="$t('dashboard.cards.my_purchases.title')"
                                        :icon-cart="true"
                                        :intro="$t('dashboard.cards.my_purchases.intro')"
                                        tag-content="1 reis, väljalend 12.01.2024"
                                        tag-color="blue-200"
                                    />
                                </router-link>
                                <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/bonuspoints`">
                                    <Card
                                        class="mt-12"
                                        :title="$t('dashboard.cards.bonuspoints.title')"
                                        :icon-star="true"
                                        :intro="$t('dashboard.cards.bonuspoints.intro')"
                                        tag-content=""
                                        tag-color=""
                                    />
                                </router-link>
                            </div>
                            <div
                                v-if="customerType === 'O' && webLinks?.length"
                                class="order-3 w-full pt-24 sm:w-3/6 md:w-2/6 md:pt-0 md:pr-12 xl:pr-24"
                            >
                                <ul>
                                    <li v-for="link in webLinks" :key="link.link_url">
                                        <LinksListItem
                                            v-if="link.link_title?.length && link.link_url?.length"
                                            :title="link.link_title"
                                            :url="link.link_url"
                                        />
                                    </li>
                                </ul>
                            </div>
                            <div
                                v-if="customerType === 'P' && webLinks?.length"
                                class="order-3 w-full pt-24 sm:w-3/6 sm:pl-12 md:w-2/6 md:pt-0 md:pl-0"
                            >
                                <ul>
                                    <li v-for="link in webLinks" :key="link.link_url">
                                        <LinksListItem
                                            v-if="link.link_title?.length && link.link_url?.length"
                                            :title="link.link_title"
                                            :url="link.link_url"
                                        />
                                    </li>
                                </ul>
                            </div>
                            <!--                            v-if äriklient-->
                            <div
                                v-if="customerType === 'O'"
                                class="order-3 w-full pt-24 sm:w-3/6 sm:pl-12 md:w-2/6 md:pt-0 md:pl-12 xl:pl-24"
                            >
                                <div class="p-24 bg-yellow-100 rounded-md">
                                    <h3 v-if="customerInfo.sales_persons" class="font-normal text-black title-lg">
                                        {{ $t('dashboard.travel_questions') }}
                                    </h3>

                                    <div
                                        v-for="person in this.customerInfo.sales_persons"
                                        :key="person.customer_id"
                                        class="flex items-center flex-1 pt-24"
                                    >
                                        <div class="relative flex-shrink-0 w-64 h-64 mr-16 overflow-hidden rounded-full">
                                            <img
                                                v-if="!person.photo"
                                                class="absolute top-0 left-0 object-cover w-full h-full"
                                                src="../assets/static/images/estravel-square.png"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                class="absolute top-0 left-0 object-cover w-full h-full"
                                                :src="person.photo"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <!--                                            TODO: Kas on võimalik, et sales_person objektil pole first või last name?-->
                                            <span v-if="person.first_name && person.last_name" class="block"
                                                >{{ person.first_name }} {{ person.last_name }}</span
                                            >
                                            <a
                                                v-if="person.business_email"
                                                :href="'mailto:' + person.business_email"
                                                class="self-text-link"
                                                >{{ person.business_email.toLowerCase() }}</a
                                            >
                                            <a v-if="person.phone" :href="'tel:' + person.phone" class="self-text-link">{{
                                                person.phone
                                            }}</a>
                                        </div>
                                    </div>

                                    <h3 v-if="customerInfo.customer_manager" class="pt-48 font-normal text-black title-lg">
                                        {{ $t('dashboard.contractual_questions') }}
                                    </h3>

                                    <div v-if="customerInfo.customer_manager" class="flex items-center flex-1 pt-24">
                                        <div class="relative flex-shrink-0 w-64 h-64 mr-16 overflow-hidden rounded-full">
                                            <img
                                                v-if="!customerInfo.customer_manager.photo"
                                                class="absolute top-0 left-0 object-cover w-full h-full"
                                                src="../assets/static/images/estravel-square.png"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                class="absolute top-0 left-0 object-cover w-full h-full"
                                                :src="customerInfo.customer_manager.photo"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <span class="block"
                                                >{{ customerInfo.customer_manager.first_name }}
                                                {{ customerInfo.customer_manager.last_name }}</span
                                            >
                                            <a :href="'mailto:' + customerInfo.customer_manager.business_email" class="self-text-link">{{
                                                customerInfo.customer_manager.business_email
                                            }}</a>
                                            <a
                                                v-if="customerInfo.customer_manager.phone"
                                                :href="'tel:' + customerInfo.customer_manager.phone"
                                                class="self-text-link"
                                                >{{ customerInfo.customer_manager.phone }}</a
                                            >
                                        </div>
                                    </div>

                                    <h3 class="pt-48 font-normal text-black title-lg">{{ $t('footer.title') }}</h3>

                                    <div class="flex items-center flex-1 pt-24">
                                        <div class="relative flex-shrink-0 w-64 h-64 mr-16 overflow-hidden rounded-full">
                                            <img
                                                class="absolute top-0 left-0 object-cover w-full h-full"
                                                src="../assets/static/images/estravel-square.png"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <a href="mailto:estravel@estravel.ee" class="self-text-link">estravel@estravel.ee</a>
                                            <a href="tel:+3726266266" class="self-text-link">+372 626 6266</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- BEST OFFERS BLOCK -->
            <BestOffersBlock
                v-if="$store.getters.getWebContents.offers?.length"
                :title="$t('dashboard.best_offers')"
                :web-content="$store.getters.getWebContents.offers.join('')"
            />
            <!-- MORE INFO BLOCK -->
            <MoreInfoBlock
                v-if="$store.getters.getWebContents.blocks?.length && $store.getters.getWebContents.blocks[0] != 'no offers found'"
            />
        </article>
    </div>
</template>

<script lang="ts">
import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Card from '../components/Card.vue';
import LinksListItem from '../components/LinksListItem.vue';
import BestOffersBlock from '../components/BestOffersBlock.vue';
import MoreInfoBlock from '../components/MoreInfoBlock.vue';
import GoldCard from '../components/GoldCard.vue';
import { ICustomer } from '@/domain/ICustomer';
import { ILink } from '@/domain/ILink';

@Component({
    components: {
        GoldCard,
        MoreInfoBlock,
        BestOffersBlock,
        LinksListItem,
        Card
    }
})
export default class DashboardView extends Vue {
    get customerInfo(): ICustomer {
        return store.getters.getCustomerInfo;
    }

    get customerType(): string {
        return store.getters.getCustomerType;
    }

    get webLinks(): ILink[] {
        return store.getters.getWebContents.links;
    }
}
</script>

<style scoped></style>
